import React from 'react';

import Layout from 'components/layout/Layout';
import Main from 'components/layout/Main';

import 'styles/index.scss';

const IndexPage = () => (
  <Layout header sidebar>
    <Main />
  </Layout>
);

export default IndexPage;
